import { useFormContext } from '@/components/form/formHooks';
import { Button, Size, Variant } from '@/components/ui/button';
import { faSpinnerThird } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

type SubmitButtonProps = {
  buttonText: string;
  variant?: Variant;
  size?: Size;
};

export function FormSubmitButton({
  buttonText,
  variant = 'default',
  size,
}: SubmitButtonProps) {
  const form = useFormContext();
  const { t } = useTranslation();
  return (
    <form.Subscribe selector={(state) => [state.isSubmitting, state.canSubmit]}>
      {([isSubmitting, canSubmit]) => {
        const buttonContent = isSubmitting ? (
          <>
            <FontAwesomeIcon icon={faSpinnerThird} spin />
            {t('actions.loading')}
          </>
        ) : (
          buttonText
        );

        return (
          <Button
            variant={variant}
            type="submit"
            size={size}
            disabled={isSubmitting || !canSubmit}
            className="gap-2">
            {buttonContent}
          </Button>
        );
      }}
    </form.Subscribe>
  );
}
